import React, { useState } from 'react';
import { useCatalog } from './../../Shared/Hooks/useCatalog';
import ImageLoader from '../../Shared/Components/Loader/ImageLoader';
import { PRODUCT_DATABASE } from '../../Data/inventoryProvider';
import './../../core/style/ProductFeed.css';
import WHATSAPP_NUMBER from "./../../core/constants/constants"
import { Helmet } from "react-helmet";

const ProductFeed = () => {
  const { data, isLoading, error } = useCatalog(PRODUCT_DATABASE);
  const [showAll, setShowAll] = useState(false);

  if (error) return <div className="error-display">Technical error: {error}</div>;

  const visibleProducts = showAll ? data : data.slice(0, 3);

  const toggleView = () => {
    setShowAll(!showAll);
    if (showAll) {
      document.getElementById('catalog')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org/",
              "@type": "Product",
              "name": "Busan M1400 Hydraulic Rock Breaker",
              "image": "https://www.busan.co.in/images/HBM1400.jpg",
              "description": "High-performance hydraulic rock breaker for 20-ton excavators.",
              "brand": {
                "@type": "Brand",
                "name": "Busan"
              },
              "offers": {
                "@type": "Offer",
                "url": "https://www.busan.co.in/",
                "priceCurrency": "INR",
                "availability": "https://schema.org/InStock"
              }
            }
          `}
        </script>
      </Helmet>
      <section className="feed-container" id="catalog">
        <div className="feed-header">
          <h2 className="reveal-text">Products</h2>
        </div>

        <div className="product-grid">
          {isLoading ? (
            Array(3).fill(0).map((_, i) => (
              <div key={`skel-${i}`} className="product-card skeleton-card" />
            ))
          ) : (
            visibleProducts.map((product, index) => (
              <div
                key={product.id}
                className="product-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="part-number-tag">{product.category}</div>
                <h3 className="card-title">{product.name}</h3>

                <div className="product-image-wrapper">
                  <ImageLoader src={product.imageUrl} alt={product.name} ratio="1/1" />
                </div>

                <p className="card-title">For any inquiry please contact us</p>

                <a
                  href={`https://wa.me/${String(WHATSAPP_NUMBER).replace(/\D/g, '')}?text=${encodeURIComponent(
                    `Hello Busan Hydraulic Rock Breaker,\n\n` +
                    `I am interested in inquiring about the following product:\n` +
                    `*Product:* ${product.name}\n\n` +
                    `Could you please provide more details and pricing?`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="shop-button"
                  onClick={(e) => e.stopPropagation()}
                  style={{ textDecoration: 'none', display: 'inline-block' }}
                >
                  Inquiry Now <span>→</span>
                </a>
                {/* 
              <div className="card-footer-text">
                Starting at {product.specs.pressure} Bar
              </div> */}
              </div>
            ))
          )}
        </div>

        {!isLoading && data.length > 3 && (
          <div className="see-all-container">
            <button className="see-all-btn" onClick={toggleView}>
              {showAll ? 'Show Less' : 'See All Products'}
              <span className={`btn-icon ${showAll ? 'icon-rotate' : ''}`}>
                ↓
              </span>
            </button>
          </div>
        )}
      </section>
    </>
  );
};

export default ProductFeed;